<faxe-page-layout>
<mat-tab-group>
  <mat-tab label="Client Event Listner">
    <faxe-client-event-listner>
    </faxe-client-event-listner>
  </mat-tab>
  <mat-tab label="Simulator">
    <faxe-sim>
    </faxe-sim>
  </mat-tab>
  <mat-tab label="RAG">
    <faxe-rag>
    </faxe-rag>
  </mat-tab>
</mat-tab-group>
</faxe-page-layout>
